
// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
// const  usd = require('utilities/usd');
const {
    SECOND_STEP
} = require('constants/index');


// @ actions
//const notification = require('actions/notifications');



// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

const requestAccessDataInProgress = () => ({
    type: actionTypes.USER_DATA_REQUEST
});

const requestUserDataReset = () =>({
     type: actionTypes.USER_DATA_RESET
})

const requestAccessKeyDataFailure = (error) => ({
    type: actionTypes.USER_DATA_FAILURE,
    payload: {
        error
    }
});

const phoneOTPSuccess = (data) => ({
    type: actionTypes.USER_PHONE_SUCCESS,
    payload: {
        data
    }
});

const setPhoneOTP = (typeDoc  , number ) => (dispatch , getState) => {
    const isAlreadyFetching = getState().userData.get('isFetching');

    if (!isAlreadyFetching) {

            const requestData = {
                 query: {
                    documento: number,
                    tipo: typeDoc
                }
            };

            dispatch(requestAccessDataInProgress());
            return  APIGet(dispatch, apiURLBuilder.getURL('requestKeysSendOTPData'), requestData)
                   .then(response => {
                        dispatch(phoneOTPSuccess(response))
                   })
                   .catch(error => {
                            dispatch(requestAccessKeyDataFailure(error))
                   });

    }
};


const setPhoneOTPDisaster = (typeDoc, number) => (dispatch, getState) => {
    const tokenCredential = getState().customerFinder.getIn(['steps', SECOND_STEP, 'token']);

    const params = {
        header: {
            openbankAuthToken: tokenCredential
        },
        query: {
            documento: number,
            tipo: typeDoc
        }
    };

    dispatch(requestAccessDataInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('requestKeysSendOTPData'), params)
        .then(response => dispatch(phoneOTPSuccess(response)))
        .catch(error => {
            dispatch(requestAccessKeyDataFailure(error))
        });

}

const GetPhoneBizum = () => (dispatch , getState) => {
    const isAlreadyFetching = getState().userData.get('isFetching');
    if (!isAlreadyFetching) {
        return new Promise(() => {
            dispatch(requestAccessDataInProgress());
            APIGet(dispatch, apiURLBuilder.getURL('requestPhoneBizumData')).then(
                response => { dispatch(phoneOTPSuccess(response))},
                error => { dispatch(requestAccessKeyDataFailure(error))}
            );
        });
    }
};

const UserDataReset = () => (dispatch) => {
        dispatch(requestUserDataReset());
};

module.exports = {
    setPhoneOTP,
    setPhoneOTPDisaster,
    GetPhoneBizum,
    UserDataReset
};
